import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TechnicalInformationComponent} from './technical-information.component';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {NgbAccordionModule} from '@ng-bootstrap/ng-bootstrap';
import {AccordionModule} from 'ng-design-system';
import {ProductDetailsSectionModule} from '../product-details-section/product-details-section.module';
import {MediaModule} from '@spartacus/storefront';
import {ClassificationsTemplateModule} from '../classifications-template/classifications-template.module';

@NgModule({
  declarations: [
    TechnicalInformationComponent,
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductTechnicalInformationComponent: {
          component: TechnicalInformationComponent
        }
      }
    }),
    I18nModule,
    NgbAccordionModule,
    ProductDetailsSectionModule,
    AccordionModule,
    MediaModule,
    ClassificationsTemplateModule
  ],
  exports: [
    TechnicalInformationComponent
  ]
})
export class TechnicalInformationModule {
}
